import store from "../store";
import constants from "../config/constants";
import { serviceGetAllDoctorDashboardTable } from "../services/DoctorDashboard.service";


export const FETCH_INIT = 'FETCH_INIT_ALL_DOCTOR';
export const FETCHED = 'FETCHED_ALL_DOCTOR';
export const FETCHED_FAIL = 'FETCHED_FAIL_ALL_DOCTOR';
export const FETCHED_FILTER = 'FETCHED_FILTER_ALL_DOCTOR';
export const FETCH_NEXT = 'FETCH_NEXT_ALL_DOCTOR';
export const FILTER = 'FILTER_ALL_DOCTOR';
export const RESET_FILTER = 'RESET_FILTER_ALL_DOCTOR';
export const SET_SORTING = 'SET_SORTING_ALL_DOCTOR';
export const SET_FILTER = 'SET_FILTER_ALL_DOCTOR';
export const SET_PAGE = 'SET_PAGE_ALL_DOCTOR';
export const CHANGE_PAGE = 'CHANGE_PAGE_ALL_DOCTOR';
export const CHANGE_STATUS = 'CHANGE_STATE_ALL_DOCTOR';
export const SET_SERVER_PAGE = 'SET_SERVER_PAGE_ALL_DOCTOR';
export const SET_ROW_SIZE = 'SET_ROW_SIZE_ALL_DOCTOR';

export const CREATE_DATA = 'CREATE_ALL_DOCTOR';
export const UPDATE_DATA = 'UPDATE_ALL_DOCTOR';
export const DELETE_ITEM = 'DELETE_ALL_DOCTOR';
export const CLEAN_ALL_DOCTOR = 'CLEAN_ALL_DOCTOR';

export function actionFetchAllDoctors(index = 1, sorting = {}, filter = {}, shouldReset = false) {
    const stateData = store.getState().all_doctor;
    const rowSize = stateData.rowsPerPage || 10;
    const finalFilter = { ...filter };

    const request = serviceGetAllDoctorDashboardTable({
        index,
        row: rowSize,
        order: sorting.order,
        sort_by: sorting.row,
        ...finalFilter,
    });
    return (dispatch) => {
        if (shouldReset) {
            dispatch({
                type: CHANGE_PAGE,
                payload: 1,
            });
        }
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: SET_FILTER, payload: filter });
            dispatch({ type: SET_SORTING, payload: sorting });
            if (!data.error) {
                dispatch({ type: FETCHED, payload: { data: data?.data, page: index } });
                dispatch({ type: SET_SERVER_PAGE, payload: index });
                if (index == 1) {
                    dispatch({ type: CHANGE_PAGE, payload: index - 1 });
                }
            } else {
                dispatch({ type: FETCHED_FAIL, payload: null });
            }
        });
    };
}




export function actionChangePageUsers(page) {
    return (dispatch) => {
        dispatch({ type: CHANGE_PAGE, payload: page })
    }
}


export function actionFilterUsers(value) {
    const request = null;
    return (dispatch) => {
        dispatch({ type: FETCH_INIT, payload: null });
        request.then((data) => {
            dispatch({ type: FILTER, payload: data });
            dispatch({ type: FETCHED, payload: null });
        });
    };
}


export function actionChangeStatusUsers(id, status) {
    return (dispatch) => {
        dispatch({ type: CHANGE_STATUS, payload: { id, status } });
    };
}

export function actionResetFilterUsers() {
    return {
        type: RESET_FILTER,
        payload: null,
    };
}

export function actionCleanAllDoctors() {
    return {
        type: CLEAN_ALL_DOCTOR,
        payload: null,
    };
}

export function actionSetRowSize(value) {
    return {
        type: SET_ROW_SIZE,
        payload: value,
    };
}

export function actionSetPageUsers(page, extraPayload) {
    const stateData = store.getState().all_doctor;
    const currentPage = stateData.currentPage;
    const totalLength = stateData.all.length;
    const sortingData = stateData.sorting_data;
    const filter = stateData.filter;
    const serverPage = stateData.serverPage;
    const rowsPerPage = stateData.rowsPerPage;

    if (totalLength <= ((page + 1) * rowsPerPage)) {
        store.dispatch(actionFetchAllDoctors(serverPage + 1, sortingData, filter, {...extraPayload}));
    }
    return {
        type: CHANGE_PAGE,
        payload: page,
    };
}

